<ng-container *ngIf="(user$ | async)?.isAuthenticated; else unauthenticated">
  <header>
    <app-toolbar [menuItems]="menu" [searchEngines]="searchEngines" [customers]="customers$ | async"
      (customerNumberChange)="onCustomerChange($event)"></app-toolbar>
  </header>

  <main class="app-body">
    <app-global-spinner></app-global-spinner>
    <div class="alert-container" *ngIf="newApplicationVersionAvailable$ | async"> 
      <span>{{ 'Angular.NewVersionAvailable' | translate }}</span>
      <button class="button-red" (click)="reloadApplication()">
        {{'Angular.Refresh' | translate}}
      </button>
    </div>
    <div class="app-content">
      <router-outlet></router-outlet>
    </div>
  </main>

  <app-twofactor-user-setup [componentMode]="'notice'"></app-twofactor-user-setup>

</ng-container>

<p-toast position="top-center"></p-toast>

<ng-template #unauthenticated>
  <div>
    <app-global-spinner></app-global-spinner>
    <router-outlet></router-outlet>
  </div>
</ng-template>

@if(displayCookieBannerSignal())
{
  <app-cookie-banner></app-cookie-banner>
}

<footer>
  {{sveaAddressSignal()}}

  <app-legal-links></app-legal-links>
</footer>
